<script>
import axios from "axios";
import VueSimpleSpinner from 'vue-simple-spinner';

export default {
  props: {
    currentUserId: {
      required: true
    },
    redirect: {
      required: true,
      type: String
    },
    currentClub: {
      default: null,
      type: String
    }
  },

  data() {
    return {
      loading: false,
      clubSelect: this.currentClub || null,
      formErrors: null
    }
  },

  components: {
    VueSimpleSpinner
  },

  methods: {
    submitForm(event) {
      this.loading = true;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendFormData(event.target);
          return;
        }

        // there was an error
        this.loading = false;
      });
    },

    submitNotMember() {
      console.log('not member');
      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      params.append(this.$root.$options.csrf.name, this.$root.$options.csrf.value);
      params.append('action', 'users/saveUser');
      params.append('userId', this.currentUserId);
      params.append('user_group', 'not-member');

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        this.goToNextPage();
      })
      .catch((error) => {
        console.log('Update Club Membership Error:', error);
        this.goToNextPage();
      })
    },

    sendFormData(form) {
      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      const formData = new FormData(form);
      for (const pair of formData.entries()) {
        params.append(
          pair[0],
          pair[1]
        );
      }

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        this.loading = false;
        // console.log(response.data);
        if (response.data.errors) {
          this.formErrors = response.data.errors
        }

        if (response.data.success) {
          this.goToNextPage();
        }
      })
      .catch((error) => {
        this.loading = false;
        this.goToNextPage();
        console.log('Update Club Membership Error:', error);
      })
    },

    goToNextPage() {
      window.location = this.redirect
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/ClubSelect.vue